import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { PriceList } from '../model/pricelist';
import { MeterMediaType } from '../model/const/enums';
import { Observable } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { ImdImport } from '../model/ImdImport';
import { LocalDate } from '../../core/model/local-date';

@Injectable()
export class ImdImportService extends DataService<ImdImport> {
  private readonly _defaultFilterFields: string[] = ['importIdentifierContains', 'importedFrom', 'importedTo'];

  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, config, messageService, ImdImport, progressBar, 'imd-import');
  }

  getFilterDefinition(): Observable<{
    importIdentifierContains: string;
    importedFrom: LocalDate;
    importedTo: LocalDate;
    selectedFields: string[];
    defaultFields: string[];
  }> {
    return this.client
      .get<any>(`${this.endpoint}/filter`)
      .pipe(
        map(res => {
          return {
            importedFrom: res.importedFrom ? LocalDate.fromDate(res.importedFrom) : null,
            importedTo: res.importedTo ? LocalDate.fromDate(res.importedTo) : null,
            importIdentifierContains: res.ImportIdentifierContains ? res.ImportIdentifierContains : '',
            selectedFields: Array.isArray(res.selectedFields) ? res.selectedFields : this._defaultFilterFields,
            defaultFields: this._defaultFilterFields,
          };
        })
      )
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }

  upload(file: File, companyId: string): Observable<string> {
    const formData = new FormData();
    formData.append('jsonData', JSON.stringify({ companyId }));
    formData.append('file', file, file.name);
    this.progressBar.start();
    return this.client.post<string>(`${this.endpoint}/upload`, formData).pipe(
      tap(() => this.messageService.showSuccess()),
      catchError(err => {
        this.messageService.showError(err);
        throw err;
      }),
      finalize(() => this.progressBar.stop())
    );
  }
}
